












































































import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
export default Vue.extend({
  components: { ModalOverlay },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
})
